// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2Ilnk","row":"Form_row__37xEI","col":"Form_col__LzAOV"};